<div class="box card-box">
  <div class="box-header">
    <h3 class="flex-end">
      <span
        class="p-r-sm"
        [ngClass]="{'b-r' : !activeGroupZone.isDated && !isMultipleCardType && !activeGroupZone.readOnly && !isInactiveContract}"
        tooltip="{{ card.validRangeLabel | translate }}"
        placement="left">
        <i class="fa fa-light fa-calendar-check" aria-hidden="true"></i>
      </span>
      <button type="button"
              class="btn btn-xs m-l-sm btn-outline-secondary"
              (click)="editCard()"
              *ngIf="!activeGroupZone.isDated && !isMultipleCardType && !activeGroupZone.readOnly && !isInactiveContract">
        <em class="fa fa-light fa-pencil-alt text-primary m-r-xs"></em>
        <span class="text-primary">{{'TOOLTIPS.edit'| translate}}</span>
      </button>
    </h3>
  </div>
  <div class="box-body">
    <div class="form-group action-label"
         *ngFor="let field of card.fields"
         [attr.data-hidden]="!field.fieldVisible || field.descriptor.hidden">
      <small *ngIf="!['BREAK_LINE', 'BLANK'].includes(field.descriptor.type)"
             class="text-muted">{{ field.descriptor.transId | translate }}</small>
      <div>
        <span class="_500" [innerHTML]="displayValue(field.value, field.descriptor)"></span>
        <ng-container *ngIf="field.value.file">
          <i aria-hidden="true" class="fa fa-light fa-download"
             [tooltip]="'EMPLOYEE_MANAGE.download' | translate"
             *ngIf="!downloading"
             (click)="downloadFile($event, field.value.file)">
          </i>
          <i aria-hidden="true" *ngIf="downloading" class="fa fa-light fa-spinner fa-spin"></i>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="card?.errorMessage" class="box-error">
    <gp-message [text]="card.errorMessage" type="alert"></gp-message>
  </div>

</div>
